import { NexusComponent } from "./nexus.component";

export class LightDocumentObjectModelNexusComponent extends NexusComponent {
    createRenderRoot() {
        return this;
    }
}